import { DocumentInterface, ProgressEventHandler } from 'features/Documents'
import { Dispatch, FC, SetStateAction } from 'react'
import { useRootStore } from 'service/useRootStore'

import { DocumentInformation, useManualQuoteDocumentsApi } from './manualQuoteDocumentsApi'
import { ManualQuoteDocumentsList } from './ManualQuoteDocumentsList'
import { ManualQuoteDocumentUploadButton } from './ManualQuoteDocumentUploadButton'

type BookingDocumentsCardProps = {
  setterForFilesToUpload: Dispatch<SetStateAction<DocumentInformation[]>>
}

export const ManualQuoteDocumentUploadComponent: FC<BookingDocumentsCardProps> = ({ setterForFilesToUpload }) => {
  const {
    authStore: {
      state: { customer },
    },
  } = useRootStore()
  const { updateLocalFileCollection, getLocalDocuments, createPreviewURL, updateLocalFile, deleteFile } =
    useManualQuoteDocumentsApi()

  const upload = async (file: File, onProgress: ProgressEventHandler, type: string): Promise<DocumentInterface> => {
    const response = await updateLocalFileCollection(file, type, customer._id, onProgress)
    setterForFilesToUpload([...response])
    return response[response.length - 1]
  }

  const replace = (file: File, existingDoc: DocumentInformation) => {
    return updateLocalFile(file, existingDoc)
  }

  return (
    <div>
      <ManualQuoteDocumentUploadButton onUpload={upload} />
      <ManualQuoteDocumentsList
        isLoading={false}
        documents={getLocalDocuments()}
        fetchPreviewUrl={(doc) => createPreviewURL(doc.fileInstance, doc.fileInstance.type)}
        onReplace={(file, doc) => {
          const response = replace(file, doc)
          setterForFilesToUpload([...response])
        }}
        onDelete={(file) => {
          const response = deleteFile(file)
          setterForFilesToUpload(() => [...response])
        }}
      />
    </div>
  )
}
